export default __webpack_public_path__ + "a5590a482834d0d2882d34e61d21187f.svg";